export default __webpack_public_path__ + "static/media/rightBackground2.450312ea.png";